export const Types = {
    GET_TASKS_PAGE: " GET_TASKS_PAGE",
    GET_STATUS_LIST: " GET_STATUS_LIST",
    GET_UPDATE_TASK_DATE: " GET_UPDATE_TASK_DATE",
    GET_TASK_DETAIL_BY_ID: " GET_TASK_DETAIL_BY_ID",
    GET_LIST_MAINTATENANCE_TYPE: " GET_LIST_MAINTATENANCE_TYPE",
    GET_EQUIPMENT_SUB_LIST_BY_ID: " GET_EQUIPMENT_SUB_LIST_BY_ID",
    GET_AREA_LIST: "GET_AREA_LIST",
    GET_MAIN_LIST_BY_AREA_ID: "GET_MAIN_LIST_BY_AREA_ID",
    GET_POOL_LIST: " GET_POOL_LIST",
    GET_SUB_LIST_BY_AREA_ID: "GET_SUB_LIST_BY_AREA_ID",
    SET_SUB_LIST_BY_AREA_ID: "SET_SUB_LIST_BY_AREA_ID",
    SET_TASKS_PAGE: "SET_TASKS_PAGE",
    SET_STATUS_LIST: "SET_STATUS_LIST",
    SET_UPDATE_TASK_DATE: "SET_UPDATE_TASK_DATE",
    SET_TASK_DETAIL_BY_ID: "SET_TASK_DETAIL_BY_ID",
    SET_LIST_MAINTATENANCE_TYPE: "SET_LIST_MAINTATENANCE_TYPE",
    SET_EQUIPMENT_SUB_LIST_BY_ID: "SET_EQUIPMENT_SUB_LIST_BY_ID",
    SET_AREA_LIST: "SET_AREA_LIST",
    SET_MAIN_LIST_BY_AREA_ID: "SET_MAIN_LIST_BY_AREA_ID",
    SET_POOL_LIST: " SET_POOL_LIST",

    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};
export const getList = () => ({
    type: Types.GET_POOL_LIST,
});
export const setList = (payload) => ({
    type: Types.SET_POOL_LIST,
    payload,
});

// export const getStatusList = () => ({

//     type: Types.GET_STATUS_LIST,

// });

export const getTaskList = (payload) => ({
    type: Types.GET_TASKS_PAGE,
    payload,
});
export const getupdateTaskDate = (payload) => ({
    type: Types.GET_UPDATE_TASK_DATE,
    payload,
});

export const setSubListById = (payload) => ({
    type: Types.SET_SUB_LIST_BY_AREA_ID,
    payload,
});

export const getTaskDetailById = (payload) => ({
    type: Types.GET_TASK_DETAIL_BY_ID,
    payload,
});

export const getListMaintenanceType = (payload) => ({
    type: Types.GET_LIST_MAINTATENANCE_TYPE,
    payload,
});

export const getEquipmentSubListById = (payload) => ({
    type: Types.GET_EQUIPMENT_SUB_LIST_BY_ID,
    payload,
});

export const getAreaList = () => ({
    type: Types.GET_AREA_LIST,
});
export const getMainListByAreaID = (payload) => ({
    type: Types.GET_MAIN_LIST_BY_AREA_ID,
    payload,
});
export const setMainListByAreaID = (payload) => ({
    type: Types.SET_MAIN_LIST_BY_AREA_ID,
    payload,
});
export const getSubListById = (payload) => ({
    type: Types.GET_SUB_LIST_BY_AREA_ID,
    payload,
});

export const setStatusList = (payload) => ({
    type: Types.SET_STATUS_LIST,
    payload,
});

export const setTaskList = (payload) => ({
    type: Types.SET_TASKS_PAGE,
    payload,
});

export const setupdateTaskDate = (payload) => ({
    type: Types.SET_UPDATE_TASK_DATE,
    payload,
});

export const setTaskDetailById = (payload) => ({
    type: Types.SET_TASK_DETAIL_BY_ID,
    payload,
});

export const setListMaintenanceType = (payload) => ({
    type: Types.SET_LIST_MAINTATENANCE_TYPE,
    payload,
});

export const setEquipmentSubListById = (payload) => ({
    type: Types.SET_EQUIPMENT_SUB_LIST_BY_ID,
    payload,
});

export const setAreaList = () => ({
    type: Types.SET_AREA_LIST,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});
